
export const LECTURETTE_TOPICS_REQUEST = "LECTURETTE_TOPICS_REQUEST";
export const LECTURETTE_TOPICS_SUCCESS = "LECTURETTE_TOPICS_SUCCESS";
export const LECTURETTE_TOPICS_FAIL = "LECTURETTE_TOPICS_FAIL";

export const LECTURETTE_CLEAR_STATE = "LECTURETTE_CLEAR_STATE";
export const LECTURETTE_CLEAR_ERROR = "LECTURETTE_CLEAR_ERROR";
